import React from 'react';
import PropTypes from 'prop-types';

const Show = (props) => {
  let result = null;
  let { condition, children, if: when } = props;
  if (condition || when) result = children;

  return result;
};

Show.propTypes = {
  condition: PropTypes.bool,
  if: PropTypes.bool,
};

export default Show;
